import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormatListItem } from '../format-list-item';
import { UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ChartTypes } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-display-label',
  templateUrl: './display-label.component.html',
  styleUrls: ['./display-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayLabelComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) field!: FormatListItem;
  @Output() update = new EventEmitter<ChartTypes.BaseFieldFormat>();

  tooltipContent = `Display label changes apply to the axis title, tooltip, data point view, and legend series for the field.`;
  form = this.fb.group({
    text: ['', { updateOn: 'blur' }],
  });
  subscription = new Subscription();

  constructor(private fb: UntypedFormBuilder) {
    this.subscription = this.form.valueChanges.subscribe(({ text: displayLabel }) => {
      this.updateDisplayLabel(displayLabel);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field) {
      this.form.patchValue({ text: this.field.baseFormatDisplayName }, { emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  updateDisplayLabel(displayLabel: string) {
    this.update.emit({ displayName: displayLabel });
  }
}
